/**
 * Loads the Voyado Product Page response once and shares it with PDP features.
 */
(function initializeVoyadoProductPageState(window) {
    'use strict';

    const context = window.VOYADO_CONTEXT?.productPage;

    if (
        !context?.enabled ||
        !window.VOYADO_ELEVATE?.createClient ||
        window.VOYADO_PRODUCT_PAGE
    ) {
        return;
    }

    const EVENT_NAME = 'voyado:product-page-state';
    const PRODUCT_KEY_PARAMETER = 'voyadoProductKey';
    const client = window.VOYADO_ELEVATE.createClient();
    const urlProductKey = new URL(window.location.href).searchParams
        .get(PRODUCT_KEY_PARAMETER);
    const productKey = String(urlProductKey || context.productKey || '').trim();

    let state = Object.freeze({
        status: 'idle',
        error: null,
        productKey,
        response: null,
    });

    function setState(patch) {
        state = Object.freeze({ ...state, ...patch });
        window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: state }));
        return state;
    }

    function subscribe(listener) {
        const handleChange = (event) => listener(event.detail);
        window.addEventListener(EVENT_NAME, handleChange);
        listener(state);
        return () => window.removeEventListener(EVENT_NAME, handleChange);
    }

    async function load() {
        if (state.status === 'loading') return state;

        if (!productKey) {
            return setState({
                status: 'error',
                error: {
                    name: 'ConfigurationError',
                    message: 'A Voyado product key is required.',
                },
            });
        }

        setState({ status: 'loading', error: null });

        try {
            const response = await client.productPage(
                { productKey },
                { productGroup: { include: true } }
            );

            return setState({
                status: 'success',
                error: null,
                response,
            });
        } catch (error) {
            return setState({
                status: 'error',
                error: {
                    name: error?.name ?? 'Error',
                    message: error?.message ?? 'Could not load the Voyado product page.',
                    status: error?.status ?? null,
                    response: error?.response ?? null,
                },
                response: null,
            });
        }
    }

    window.VOYADO_PRODUCT_PAGE = Object.freeze({
        getState: () => state,
        subscribe,
        load,
    });

    load();
})(window);
